<template>
	<div
		class="event-list-item-time"
	>
		<span>{{ time }}</span>
		<slot />
	</div>
</template>

<script>
export default {
	name:  'EventListItemTime',
	props: {
		time: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-time {
	@include font(primary, medium, normal, fs-80);
	display: flex;
	position: relative;
	align-items: flex-start;
	flex-direction: column;
	justify-content: center;
	row-gap: $sp2;
	color: var(--color-grey-200);
	text-align: left;
	white-space: nowrap;

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		color: var(--color-grey-300);
	}

	@include size(md-up) {
		width: calc(100% + #{$sp5});
		min-width: 0;
		height: 100%;
		margin-left: -$sp5;
		text-align: center;
		align-items: center;
		justify-content: center;

		&.-volley {
			width: 100%;
			margin-left: 0;
			padding-right: $sp4;
			text-align: left;
			align-items: flex-start;
		}

		&::after {
			display: block;
			position: absolute;
			top: 50%;
			right: 0;
			width: 1px;
			height: 40px;
			transform: translateY(-50%);
			content: '';
			background-color: var(--color-grey-700);
		}
	}
}
</style>
